import { Form, InputNumber } from "antd"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"


export const Deposit = ({ form }) => {
  const fullPaymentRequired = Form.useWatch("full_payment_required", form)
  const [t] = useTranslation()

  return (
    <Form.Item
      name="deposit_percentage"
      label={t("experiences.scheduling.sections.length_and_rates.deposit")}
      extra={t("experiences.scheduling.sections.length_and_rates.deposit_info")}
      rules={[{ required: true, message: t("form_validation.cannot_be_blank") }]}
    >
      <InputNumber
        size="large"
        min={10}
        disabled={fullPaymentRequired
        }
        max={50}
        formatter={(value) => `${value}%`}
        parser={(value) => value?.replace("%", "")}
        className="w-100"
      />
    </Form.Item>
  )
}
Deposit.propTypes = {
  form: PropTypes.shape({
    getFieldValue: PropTypes.func,
    setFieldsValue: PropTypes.func,
  }).isRequired,
}
